import { ISitecoreItem } from '@/interfaces';

/**
 * If a single rule returns true it will show the edit link.
 * Default to `true`.
 */
export const executeEditRules = (
  executeRules: { [K: string]: (data: any) => boolean },
  rules: ISitecoreItem[],
  data: any
) => {
  if (rules && rules.length > 0) {
    const anyRuleIsTrue = rules.some(function (rule) {
      if (executeRules[rule.name]) {
        return executeRules[rule.name](data);
      }
    });
    return anyRuleIsTrue;
  }

  return true;
};
